import { SVGProps } from 'react'

interface PointIconProps extends SVGProps<SVGSVGElement> {
    height?: string
    width?: string
}

const PointIcon = ({ height = '17', width = '17' }: PointIconProps) => {
    return (
        <svg width={height} height={width} viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M3.06655 6.24657C2.96925 5.80825 2.98419 5.35246 3.10999 4.92146C3.23579 4.49046 3.46838 4.0982 3.7862 3.78105C4.10401 3.4639 4.49676 3.23213 4.92802 3.10723C5.35929 2.98233 5.81511 2.96835 6.25322 3.06657C6.49436 2.68944 6.82655 2.37907 7.21918 2.16409C7.61182 1.94911 8.05225 1.83643 8.49988 1.83643C8.94752 1.83643 9.38795 1.94911 9.78058 2.16409C10.1732 2.37907 10.5054 2.68944 10.7466 3.06657C11.1853 2.96792 11.6419 2.98184 12.0739 3.10704C12.5058 3.23225 12.8991 3.46466 13.2171 3.78267C13.5351 4.10068 13.7675 4.49395 13.8927 4.9259C14.0179 5.35786 14.0319 5.81446 13.9332 6.25324C14.3104 6.49437 14.6207 6.82657 14.8357 7.2192C15.0507 7.61183 15.1634 8.05227 15.1634 8.4999C15.1634 8.94754 15.0507 9.38797 14.8357 9.7806C14.6207 10.1732 14.3104 10.5054 13.9332 10.7466C14.0314 11.1847 14.0175 11.6405 13.8926 12.0718C13.7677 12.503 13.5359 12.8958 13.2187 13.2136C12.9016 13.5314 12.5093 13.764 12.0783 13.8898C11.6473 14.0156 11.1915 14.0305 10.7532 13.9332C10.5124 14.3118 10.1799 14.6235 9.78663 14.8394C9.39333 15.0554 8.9519 15.1686 8.50322 15.1686C8.05453 15.1686 7.6131 15.0554 7.2198 14.8394C6.8265 14.6235 6.49404 14.3118 6.25322 13.9332C5.81511 14.0315 5.35929 14.0175 4.92802 13.8926C4.49676 13.7677 4.10401 13.5359 3.7862 13.2188C3.46838 12.9016 3.23579 12.5093 3.10999 12.0783C2.98419 11.6473 2.96925 11.1916 3.06655 10.7532C2.68652 10.5127 2.37349 10.18 2.15658 9.78605C1.93967 9.39207 1.82593 8.94964 1.82593 8.4999C1.82593 8.05016 1.93967 7.60773 2.15658 7.21376C2.37349 6.81979 2.68652 6.48707 3.06655 6.24657Z'
                fill='#1CB954'
                stroke='#1CB954'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <g clipPath='url(#clip0_288_2063)'>
                <path
                    d='M6.16638 6.1665V10.8332'
                    stroke='white'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M7.62488 6.1665V10.8332'
                    stroke='white'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9.0835 6.1665V10.8332'
                    stroke='white'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M10.5414 6.1665V10.8332'
                    stroke='white'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M11.417 6.75L5.58362 10.25'
                    stroke='white'
                    strokeWidth='0.666667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_288_2063'>
                    <rect width='7' height='7' fill='white' transform='translate(5 5)' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default PointIcon
